import router from '../router/index.js'
function executeHttpCode(code){
	switch (code){
		case 200: //console.log("成功！");
		break;
		case 400: console.log("请求错误！");break;
		case 500: console.log("服务器异常！");break;
		case 401: console.log("未登录！",router); localStorage.removeItem("token") ;router.push("/");break;
		case 404: console.log("找不到资源！");break;
		default: console.log("不处理")		
	}
	
	

}

export default executeHttpCode